import { usePageMetadata } from '../hooks/usePageMetadata'

export default function Impressum() {
  usePageMetadata({
    title: 'Impressum | Places in Time',
    description:
      'Find the provider information and contact details for the operator of Places in Time.',
    path: '/impressum',
  })

  return (
    <main className="page legal-page">
      <section className="page-hero">
        <h1>Impressum</h1>
        <p>Angaben gemäß § 5 DDG</p>
      </section>

      <section className="page-section">
        <p>
          Alexander Bunting<br />
          Engelhardstraße 36<br />
          63450 Hanau<br />
          Deutschland
        </p>
      </section>

      <section className="page-section">
        <p>
          E-Mail:{' '}
          <a href="mailto:infoplacesintime@gmail.com">
            infoplacesintime@gmail.com
          </a>
        </p>
      </section>

      <section className="page-section">
        <h2>Verantwortlich für den Inhalt</h2>
        <p>
          Alexander Bunting<br />
          Adresse wie oben
        </p>
      </section>
    </main>
  )
}
